
import Dashboard from "views/pages/dashboards/Dashboard.js";
import Products from "views/pages/tables/Products.js";
import Invoice from "views/pages/invoice/Invoice.js";
import Users from "views/pages/users/Users.js";
import Customers from "views/pages/customers/Customers.js";
import AddUser from "views/pages/users/AddUser";
import AddProducts from "views/pages/tables/AddProducts";
import AddCustomers from "views/pages/customers/AddCustomers";
import AddInvoice from "views/pages/invoice/AddInvoice";
import Category from "views/pages/category/Category";
import AddCategory from "views/pages/category/AddCategory";
import Einvoice from "views/pages/einvoice/Invoice";
import AddEinvoice from "views/pages/einvoice/AddEinvoice";
import Wallet from "views/pages/accounts/wallet";




const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    isHidden: false,
    icon: "ni ni-shop text-primary",
    miniName: "D",
    component: <Dashboard />,
    layout: "/admin",
  },
  {
    path: "/users",
    name: "Users",
    collapse: true,
    views: [
      {
        path: "/users",
        name: "Users",
        isHidden: false,
        icon: "ni ni-single-02 text-default",
        miniName: "US",
        component: <Users />,
        layout: "/admin",
      },
      {
        path: "/adduser",
        name: "Add User",
        icon: "ni ni-fat-add",
        miniName: "IN",
        component: <AddUser />,
        layout: "/admin",
      },
    ],
    isHidden: false,
    icon: "ni ni-circle-08 text-orange",
    miniName: "US",
    component: <Users />,
    layout: "/admin",
  },
  {
    collapse: true,
    name: "Einvoices",
    icon: "ni ni-paper-diploma text-black",
    state: "einvoiceCollapse",
    views: [
      {
        path: "/einvoice",
        name: "Einvoice",
        isHidden: false,
        icon: "ni ni-calendar-grid-58 text-default",
        miniName: "IN",
        component: <Einvoice />,
        layout: "/admin",
      },

      {
        path: "/addeinvoices",
        name: "Add einvoice",
        icon: "ni ni-fat-add",
        miniName: "PRO",
        component: <AddEinvoice />,
        layout: "/admin",
      },
    ],
  },
];

const premiumRoutes = [
  {
    path: "/dashboard",
    name: "sidenav.dash",
    isHidden: false,
    icon: "ni ni-shop text-primary",
    miniName: "D",
    component: <Dashboard />,
    layout: "/admin",
  },

  {
    path: "/users",
    name: "sidenav.profile",
    isHidden: false,
    icon: "ni ni-single-02 text-default",
    miniName: "US",
    component: <Users />,
    layout: "/admin",
  },
  {
    collapse: true,
    name: "sidenav.category",
    icon: "ni ni-briefcase-24 text-info",
    state: "categoryCollapse",
    views: [
      {
        path: "/category",
        name: "sidenav.category",
        isHidden: false,
        icon: "ni ni-box-2",
        miniName: "D",
        component: <Category />,
        layout: "/admin",
      },
      {
        path: "/addcategories",
        name: "sidenav.add_category",
        icon: "ni ni-fat-add",
        miniName: "PRO",
        component: <AddCategory />,
        layout: "/admin",
      },
    ],
  },

  {
    collapse: true,
    name: "sidenav.product",
    icon: "ni ni-books text-pink",
    state: "productsCollapse",
    views: [
      {
        path: "/product",
        name: "sidenav.product",
        isHidden: false,
        icon: "ni ni-cart",
        miniName: "PRO",
        component: <Products />,
        layout: "/admin",
      },
      {
        path: "/addproducts",
        name: "sidenav.add_product",
        icon: "ni ni-fat-add",
        miniName: "PRO",
        component: <AddProducts />,
        layout: "/admin",
      },
    ],
  },
  {
    collapse: true,
    name: "sidenav.customer",
    icon: "ni ni-satisfied text-green",
    state: "customersCollapse",
    views: [
      {
        path: "/customers",
        name: "sidenav.customer",
        isHidden: false,
        icon: "ni ni-circle-08 text-default",
        miniName: "US",
        component: <Customers />,
        layout: "/admin",
      },
      {
        path: "/addcustomers",
        name: "sidenav.add_customer",
        icon: "ni ni-fat-add",
        miniName: "PRO",
        component: <AddCustomers />,
        layout: "/admin",
      },
    ],
  },
  {
    collapse: true,
    name: "sidenav.invoice",
    icon: "ni ni-paper-diploma text-red",
    state: "invoiceCollapse",
    views: [
      {
        path: "/invoice",
        name: "sidenav.invoice",
        isHidden: false,
        icon: "ni ni-calendar-grid-58 text-default",
        miniName: "IN",
        component: <Invoice />,
        layout: "/admin",
      },

      {
        path: "/addinvoices",
        name: "sidenav.add_invoice",
        icon: "ni ni-fat-add",
        miniName: "PRO",
        component: <AddInvoice />,
        layout: "/admin",
      },
    ],
  },
  // {
  //   collapse: true,
  //   name: "sidenav.accounts",
  //   icon: "ni ni-credit-card text-green",
  //   state: "accountCollapse",
  //   views: [
  //     {
  //       path: "/wallet",
  //       name: "sidenav.wallet",
  //       isHidden: false,
  //       icon: "ni ni-credit-card text-default",
  //       miniName: "IN",
  //       component: <Wallet />,
  //       layout: "/admin",
  //     },
  //   ],
  // },
  // {
  //   collapse: true,
  //   name: "Suppliers",
  //   icon: "ni ni-satisfied text-brown",
  //   state: "suppliersCollapse",
  //   views: [
  //     {
  //       path: "/suppliers",
  //       name: "Supplier",
  //       isHidden: false,
  //       icon: "ni ni-circle-08 text-default",
  //       miniName: "US",
  //       component: <Suppliers />,
  //       layout: "/admin",
  //     },
  //     {
  //       path: "/addsuppliers",
  //       name: "Add Suppliers",
  //       icon: "ni ni-fat-add",
  //       miniName: "PRO",
  //       component: <AddSuppliers />,
  //       layout: "/admin",
  //     },
  //   ],
  // },
  // {
  //   collapse: true,
  //   name: "Purchase Invoices",
  //   icon: "ni ni-paper-diploma text-red",
  //   state: "purchaseinvoiceCollapse",
  //   views: [
  //     {
  //       path: "/purchaseinvoice",
  //       name: "Purchase Invoice",
  //       isHidden: false,
  //       icon: "ni ni-calendar-grid-58 text-default",
  //       miniName: "IN",
  //       component: <PurchaseInvoice />,
  //       layout: "/admin",
  //     },

  //     {
  //       path: "/addpurchaseinvoices",
  //       name: "Add Invoice",
  //       icon: "ni ni-fat-add",
  //       miniName: "PRO",
  //       component: <AddPurchaseInvoice />,
  //       layout: "/admin",
  //     },
  //   ],
  // },
  // {
  //   path: "/history",
  //   name: "History",
  //   isHidden: false,
  //   icon: "ni ni-calendar-grid-58 text-primary",
  //   miniName: "IN",
  //   component: <History />,
  //   layout: "/admin",
  // },
];
export { routes, premiumRoutes };
